const focusElement = (target: HTMLElement | null, delay: number = 50) => {
	let quickFocus = true;
	if (target) {
		const stickyParent = target.closest(".sticky-inner-container");
		if (stickyParent) {
			if (stickyParent.classList.contains("fixed-sticky") && target.getBoundingClientRect().top < 0) {
				const container = target.closest(".sticky-container") as HTMLDivElement;

				window.scrollTo(
					0,
					container.offsetTop +
						(target.getBoundingClientRect().top - stickyParent.getBoundingClientRect().top) -
						20
				);
				quickFocus = false;
				setTimeout(() => {
					target.focus();
				}, 1000);
			}
		}
		if (quickFocus) {
			setTimeout(() => {
				target.focus();
			}, delay);
		}
	}
};

export const useFocusElement = () => {
	return focusElement;
};
